import React from 'react';
import classNames from 'classnames';
export function BuyTag(_a) {
    var className = _a.className, style = _a.style, label = _a.label, children = _a.children;
    return (React.createElement("div", { className: classNames('buy-tag', className), style: style },
        label && React.createElement("span", { className: "buy-tag-label" }, label),
        React.createElement("span", { className: "buy-tag-content" }, children)));
}
//# sourceMappingURL=BuyTag.js.map